import React, { useEffect, useState } from "react";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import SeoAdd from "../Seo/SeoAdd";
import { ROUTE } from "../../route/Route";
import { useTranslation } from "react-i18next";
import styles from "./checkout.module.css";
import LoginVerify from "./Tabs/LoginVerify";
import Schedual from "./Tabs/Schedual";
import Payoption from "./Tabs/Payoption";
import Member from "./Tabs/Member";
import Address from "./Tabs/Address";
import CartBox from "./Tabs/CartBox";
import { convertToDate, getSelectedCityData, getUser } from "../../constant/utils";
import { checkOutAction, profileAction } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { setBookingDataResponse } from "../../redux/checkout/reducer";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

const CheckOut = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const USER: any = getUser();
  const CityId: any = localStorage.getItem("oq:city");
  const selectedCityData: any = getSelectedCityData();
  const ExistCardData: any[] = JSON.parse(localStorage.getItem("CartData") || "[]");
  const [totalPayble, setTotalPayble] = useState<number>(0);
  const [cardEntry, setCardEntry] = useState<any[]>(ExistCardData || []);
  const bookingData: any = useSelector((state: any) => (state.checkout.bookingData ? state.checkout.bookingData : {}));
  // console.log(bookingData, "jsxbhsxbaj")
  const bookingValidation: any = useSelector((state: any) =>
    state.checkout.bookingValidation ? state.checkout.bookingValidation : {}
  );
  const customerData: any = useSelector((state: any) =>
    state.profile.patientList ? state.profile.patientList?.[0] : {}
  );
  const addressData: any[] = useSelector((state: any) => (state.profile.addressList ? state.profile.addressList : []));
  const profileData: any = useSelector((state: any) => (state.profile.profileData ? state.profile.profileData : {}));
  const slotData: any = useSelector((state: any) => (state.checkout.slot ? state.checkout.slot : []));
  const handleBookingData = (data: any) => {
    dispatch(setBookingDataResponse(data));
  };
  const patientData: any = useSelector((state: any) =>
    state.profile.patientList ? state.profile.patientList?.[0] : {}
  );
  useEffect(() => {
    window?.scrollTo(0, 0);
    dispatch(profileAction.profileMasterAction({}));
    dispatch(profileAction.stateListAction({}));
    return () => {};
  }, []);

  useEffect(() => {
    if (USER?.Id) {
      let editBookingData: any = JSON.parse(localStorage.getItem("editBooking") || "{}");
      let userdatas = {
       "UserData": {"Id": USER?.Id}
      };
      dispatch(profileAction.getProfileAction(userdatas));
      
      dispatch(profileAction.addressListAction(userdatas));
      dispatch(
        profileAction.patientListAction(
          {},
          (res: any) =>
            !bookingData?.isBookingEdit &&
            handleBookingData({
              ...bookingData,
              tab: "member",
              ...editBookingData,
            })
        )
      );
    } else {
      !bookingData?.isBookingEdit && handleBookingData({ ...bookingData, tab: "login" });
    }
  }, [USER?.Id]);

  const getSelectedMember = (_data: any) => {
    // console.log(customerData?.details?.id , _data?.patient_id,"ggggg");
    if (customerData?.details?.id == _data?.patient_id) {
      return customerData;
    } else if (customerData?.details?.first_name == _data?.patient_firstname) {
      return customerData;
    } else {
      return customerData?.family?.find((ele: any) => ele?.details?.id == _data?.patient_id);
    }
  };

  useEffect(() => {
    if (bookingData?.isBookingEdit) {
      let _data: any = bookingData?.bookingEditData;
      dispatch(
        checkOutAction.availableSlotAction({ Date: _data?.schedule_date }, async (_slot: any) => {
          // const ciId = Promise.all(
          //   addressData?.find((ele: any) => ele?.id === _data?.address_id)
          // );
          dispatch(
            checkOutAction.bookingValidationAction(
              {
                CityId: _data.city_id,
                PreferredDate: _data?.schedule_date,
                PreferredTime: _slot?.find((ele: any) =>
                  ele?.startsWith(moment(_data?.schedule_time, "HH:mm:ss").format("h.mm A"))
                ),
              },
              (data: any) => {
                handleBookingData({
                  ...bookingData,
                  tab: "payment",
                  selectedAddress: addressData?.find((ele: any) => ele?.id === _data?.address_id),
                  selectedMember: {
                    ...getSelectedMember(_data),
                    dob: convertToDate(getSelectedMember(_data)?.dob),
                  },
                  ScheduleDate: _data?.schedule_date,
                  ScheduleTime: _slot?.find((ele: any) =>
                    ele?.startsWith(moment(_data?.schedule_time, "HH:mm:ss").format("h.mm A"))
                  ),
                  PaymentMode: /* _data?.payment_type */ "cod",
                  bookingEditData: {
                    ..._data,
                    schedule_time_new: _slot?.find((ele: any) =>
                      ele?.startsWith(moment(_data?.schedule_time, "HH:mm:ss").format("h.mm A"))
                    ),
                  },
                });
              }
            )
          );
        })
      );
    }
  }, [bookingData?.isBookingEdit, addressData]);

  const handleTab = (_tab: any) => {
    if (
      (_tab == "login" && USER?.Id) ||
      (_tab == "member" && !USER?.Id) ||
      (_tab == "address" && !(bookingData?.selectedMember?.pid || bookingData?.selectedMember?.id)) ||
      (_tab == "schedual" && !bookingData?.selectedAddress?.id) ||
      (_tab == "payment" && !(bookingData?.ScheduleDate && bookingData?.ScheduleTime))
    ) {
    } else {
      handleBookingData({
        ...bookingData,
        tab: _tab === bookingData?.tab ? "" : _tab,
      });
    }
  };

  function getTime(time: any) {
    if (time) {
      time = time?.split("to");
      time = time?.[0]?.trim()?.replace("AM", "")?.replace("PM", "");
      return time ? moment(bookingData?.ScheduleTime, "hh:mm A").format("HH:mm") : "";
    } else {
      return "";
    }
  }

  const handleCreateBooking = () => {
    if (!bookingValidation?.orderStatusInCity?.isServiceActive) {
      toast.error(bookingValidation?.orderStatusInCity?.message);
      return false;
    }
    if (!bookingValidation?.orderStatusInCity?.status) {
      toast.error(bookingValidation?.orderStatusInCity?.message);
      return false;
    }
    if (!bookingValidation?.priorHoursCappingStatus) {
      toast.error(bookingValidation?.orderStatusInCity?.message);
      return false;
    }
    const patientDob = convertToDate(bookingData?.selectedMember?.dob);
    const patientRelation = bookingData?.selectedMember?.relation;
    if (!patientDob) {
      toast.error("Please add patient Dob in Member Detail");
      return;
    }

    if (!patientRelation) {
      toast.error("Please add patient relation in Member Detail");
      return;
    }
    const addressLocality = bookingData?.selectedAddress?.locality_name;
    if (!addressLocality) {
      toast.error("Address locality is missing.");
      return;
    }
    let payload: any = {
      CrmStateId: bookingData?.selectedAddress?.crmstate_id,
      CrmCityId: bookingData?.selectedAddress?.crmcity_id,
      PId: customerData?.pid,
      HouseNo: bookingData?.selectedAddress?.house_no,
      Salutation: bookingData?.selectedMember?.salutation,
      CustomerEmail: customerData?.email_id || profileData?.email_id || "",
      PatientFirstName: bookingData?.selectedMember?.first_name,
      PatientLastName: bookingData?.selectedMember?.last_name,
      PatientGender: bookingData?.selectedMember?.gender?.toLowerCase(),
      PatientDob: patientDob,
      PatientRelation: patientRelation,
      PatientMobile: bookingData?.selectedMember?.mobile_no,
      CustomerAddressLine1: addressLocality,
      CustomerCityId: bookingData?.selectedAddress?.city_id,
      CustomerStateId: bookingData?.selectedAddress?.state_id,
      CustomerName: `${customerData?.first_name} ${customerData?.last_name}`,
      CustomerPincode: bookingData?.selectedAddress?.pincode,
      ScheduleDate: bookingData?.ScheduleDate,
      ScheduleTime: getTime(bookingData?.ScheduleTime),
      CartItem: JSON.parse(localStorage.getItem("CartData") || "[]"),
      UserId: USER?.Id,
      MobileNo: customerData?.mobile_no || USER?.MobileNumber,
      PaymentMode: bookingData?.PaymentMode,
      AddressId: bookingData?.selectedAddress?.id,
      PatientId: bookingData?.selectedMember?.details?.id,
    };
    localStorage.setItem(
      "CustomerName",
      `${bookingData?.selectedMember?.first_name} ${bookingData?.selectedMember?.last_name}`
    );
    if (payload?.CartItem && Array.isArray(payload?.CartItem) && payload?.CartItem?.length > 0) {
      if (bookingData?.isBookingEdit) {
        dispatch(
          checkOutAction.updateBookingAction(
            {
              ...payload,
              EmailId: bookingData?.selectedMember?.details?.email_id,
              Relation: bookingData?.selectedMember?.details?.relation,
              BookingId: bookingData?.bookingEditData?.id,
              CrmBookingId:
                bookingData?.bookingEditData?.CrmBookingData?.id || bookingData?.bookingEditData?.crm_booking_id,
              RefundFlag:
                (totalPayble - Number(bookingData?.bookingEditData?.advance_paid || 0) || 0) < 0 ? true : false,
            },
            history
          )
        );
      } else {
        dispatch(checkOutAction.createBookingAction(payload, history));
      }
    } else {
      toast.error("Card is Empty");
    }
  };

  return (
    <React.Fragment>
      <SeoAdd slug={ROUTE.CHECKOUT} />
      <BreadCrumb page={t("checkout")} data={{ slug: "", path: "" }} />
      <section className={`${styles.fontFamily} bg-gray section pt-3`}>
        <div className="container" id="section2">
          <div className="row">
            <div className="col-md-8">
              <ul>
                <li className={!USER?.Id && bookingData?.tab === "login" ? styles.tabActive : styles.tab}>
                  <div className={styles.tabLabel} onClick={() => handleTab("login")}>
                    <span className="text-capitalize">
                      {USER?.Id ? `${USER?.FirstName || ""} ${USER?.MobileNo || ""}` : "Login/Register"}
                    </span>
                    {USER?.Id && <img src="assets/img/my-profile/steptick.png" />}
                  </div>
                  {bookingData?.tab === "login" && !USER?.Id && (
                    <div className={styles.tabDes}>
                      <LoginVerify bookingData={bookingData} setBookingData={handleBookingData} />
                    </div>
                  )}
                </li>
                {selectedCityData?.IsHcAvailable == 1 ? (
                  <>
                    <li className={bookingData?.tab === "member" ? styles.tabActive : styles.tab}>
                      <div className={styles.tabLabel} onClick={() => handleTab("member")}>
                        <span>Select Member</span>
                        {(bookingData?.selectedMember?.pid || bookingData?.selectedMember?.id) && (
                          <img src="assets/img/my-profile/steptick.png" />
                        )}
                      </div>
                      {bookingData?.tab === "member" && (
                        <div className={styles.tabDes}>
                          <Member
                            bookingData={bookingData}
                            setBookingData={handleBookingData}
                            cardEntry={cardEntry}
                            setCardEntry={setCardEntry}
                          />
                        </div>
                      )}
                    </li>

                    <li className={bookingData?.tab === "address" ? styles.tabActive : styles.tab}>
                      <div className={styles.tabLabel} onClick={() => handleTab("address")}>
                        <span>Add Sample Collection Address</span>
                        {bookingData?.selectedAddress?.id && <img src="assets/img/my-profile/steptick.png" />}
                      </div>
                      {bookingData?.tab === "address" && (
                        <div className={styles.tabDes}>
                          <Address bookingData={bookingData} setBookingData={handleBookingData} />
                        </div>
                      )}
                    </li>
                    <li className={bookingData?.tab === "schedual" ? styles.tabActive : styles.tab}>
                      <div className={styles.tabLabel} onClick={() => handleTab("schedual")}>
                        <span>Preferred Time Slot for Lab</span>
                        {bookingData?.ScheduleTime && bookingData?.ScheduleDate && (
                          <img src="assets/img/my-profile/steptick.png" />
                        )}
                      </div>
                      {bookingData?.tab === "schedual" && (
                        <div className={styles.tabDes}>
                          <Schedual bookingData={bookingData} setBookingData={handleBookingData} />
                        </div>
                      )}
                    </li>
                    <li className={bookingData?.tab === "payment" ? styles.tabActive : styles.tab}>
                      <div className={styles.tabLabel} onClick={() => handleTab("payment")}>
                        <span>Payment Option</span>
                        {bookingData?.PaymentMode && <img src="assets/img/my-profile/steptick.png" />}
                      </div>
                      {bookingData?.tab === "payment" && (
                        <div className={styles.tabDes}>
                          <Payoption
                            totalPayble={totalPayble - Number(bookingData?.bookingEditData?.advance_paid || 0) || 0}
                            bookingData={bookingData}
                            setBookingData={handleBookingData}
                            handleCreateBooking={handleCreateBooking}
                          />
                        </div>
                      )}
                    </li>
                  </>
                ) : (
                  <>
                    {USER?.Id ? (
                      <div
                        style={{
                          color: "red",
                          fontSize: "22px",
                          backgroundColor: "#fff",
                          padding: "15px",
                        }}
                      >{`Currently online booking facilty is not available in the ${selectedCityData?.Name}. Our team will contact you back.`}</div>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </ul>
            </div>
            <div className="col-md-4">
              <CartBox
                bookingValidation={bookingValidation}
                totalPayble={totalPayble - Number(bookingData?.bookingEditData?.advance_paid || 0) || 0}
                setTotalPayble={setTotalPayble}
                bookingData={bookingData}
                setBookingData={handleBookingData}
                cardEntry={cardEntry}
                setCardEntry={setCardEntry}
              />
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default CheckOut;
